import { render, staticRenderFns } from "./AddressProjectSpecifications.vue?vue&type=template&id=f184f032&scoped=true&lang=pug&"
import script from "./AddressProjectSpecifications.vue?vue&type=script&lang=ts&"
export * from "./AddressProjectSpecifications.vue?vue&type=script&lang=ts&"
import style0 from "./AddressProjectSpecifications.vue?vue&type=style&index=0&id=f184f032&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f184f032",
  null
  
)

export default component.exports